export const EXCLUDED_COUNTRIES = new Set<string>(['Australia', 'New Zealand']);
export const EXCLUDED_COUNTRIES_LOWER = new Set<string>(
  Array.from(EXCLUDED_COUNTRIES).map((country) => country.trim().toLowerCase())
);
export const EXCLUDED_COUNTRY_ISOS = new Set<string>(['AU', 'NZ']);
export const EXCLUDED_CENTRE_NAMES = new Set<string>(['Washington', 'Miami', 'Oxford']);

export function isExcludedCountry(label?: string | null, iso?: string | null): boolean {
  const normalizedLabel = (label ?? '').trim();
  if (normalizedLabel) {
    if (EXCLUDED_COUNTRIES.has(normalizedLabel)) return true;
    if (EXCLUDED_COUNTRIES_LOWER.has(normalizedLabel.toLowerCase())) return true;
  }
  if (iso) {
    const normalizedIso = iso.trim().toUpperCase();
    if (EXCLUDED_COUNTRY_ISOS.has(normalizedIso)) return true;
  }
  return false;
}

export function isExcludedCentreOrSchoolName(name?: string | null): boolean {
  const normalized = (name ?? '').trim();
  return normalized !== '' && EXCLUDED_CENTRE_NAMES.has(normalized);
}